import { PayloadAction } from "@reduxjs/toolkit";
import { toggleSortCriteria } from "./dataSort";

export type OrderedBy = {
  orderBy: string;
  criteria: "asc" | "desc";
  dataType?: "string" | "date" | "number";
};

export type ChangeOrderPayload = {
  orderBy: string;
  dataType?: "string" | "date" | "number";
  criteria?: "asc" | "desc";
};

// Shared "change sort order" reducer: re-clicking the current column toggles
// its direction, clicking a different column switches to it and resets to
// asc. Shared by every list reducer's changeOrder case (and by
// clientWork.reducer's changeWorkOrdersOrder/changeProjectsOrder, which sort
// a different field on the same state - pass that field's key as
// orderedByKey).
export const createChangeOrderReducer =
  <S extends Record<string, any>>(orderedByKey: keyof S) =>
  (state: S, action: PayloadAction<ChangeOrderPayload>) => {
    const currentOrderedBy = state[orderedByKey] as OrderedBy;
    const newOrderedBy: OrderedBy = {
      ...action.payload,
      criteria: action.payload.criteria ? action.payload.criteria : "asc",
    };
    if (newOrderedBy.orderBy === currentOrderedBy.orderBy) {
      newOrderedBy.criteria = action.payload.criteria
        ? action.payload.criteria
        : toggleSortCriteria(currentOrderedBy.criteria);
    }
    return { ...state, [orderedByKey]: newOrderedBy };
  };
